export const blogCategories = [
  { id: 'geral', label: 'Informações Gerais' },
  { id: 'especialidades', label: 'Especialidades Médicas' },
];

export const blogArticles = [
  {
    slug: 'ia-generativa-saude-seguranca-qualidade-consultorio',
    category: 'geral',
    title: 'IA generativa na saúde: como usar sem abrir mão de segurança, qualidade e responsabilidade',
    description:
      'O que médicos, dentistas e gestores precisam observar antes de levar ferramentas de IA generativa para atendimento, comunicação com pacientes e rotinas administrativas.',
    specialty: 'Gestão clínica',
    audience: 'Médicos, dentistas, clínicas e operadoras',
    updatedAt: '2026-05-25',
    readingMinutes: 8,
    keywords: ['IA na saúde', 'inteligência artificial médica', 'segurança do paciente', 'LLM em medicina'],
    sources: [
      {
        label: 'New England Journal of Medicine - Generative AI in Medicine',
        url: 'https://www.nejm.org/doi/10.1056/NEJMsb2503956',
      },
      {
        label: 'JAMA - Testing and Evaluation of Health Care Applications of Large Language Models',
        url: 'https://pubmed.ncbi.nlm.nih.gov/39405325/',
      },
    ],
    sections: [
      {
        heading: 'Por que este tema entrou na agenda clínica',
        body:
          'A IA generativa deixou de ser apenas uma promessa tecnológica e passou a aparecer em respostas a pacientes, sumarização de prontuários, triagem administrativa, educação em saúde e apoio à decisão. Para profissionais, a oportunidade é reduzir tarefas repetitivas e melhorar acesso à informação; o risco é delegar juízo clínico a sistemas que ainda podem errar, omitir contexto ou produzir respostas convincentes sem base suficiente.',
      },
      {
        heading: 'O que observar antes de adotar',
        body:
          'A primeira pergunta não deve ser “qual ferramenta usar?”, mas “qual tarefa clínica ou operacional precisa melhorar?”. Respostas a pacientes, busca em protocolos, pré-consulta e organização documental têm riscos diferentes. Ferramentas usadas em saúde precisam de revisão humana, registro do uso, proteção de dados, política de consentimento quando aplicável e limites claros para não substituir diagnóstico, prescrição ou conduta individualizada.',
      },
      {
        heading: 'Como transformar IA em qualidade, não em ruído',
        body:
          'A adoção mais madura começa por fluxos de baixo risco e alto volume: rascunhos de mensagens, preparação de materiais educativos, resumo administrativo e checagem de completude de informações. A equipe deve validar fontes, treinar linguagem segura e medir indicadores como tempo economizado, retrabalho, satisfação do paciente, incidentes e taxa de revisão necessária.',
      },
      {
        heading: 'Mensagem prática para profissionais',
        body:
          'A IA pode ser uma camada útil de produtividade, mas a confiança deve ser conquistada por validação, governança e auditoria. Em saúde, velocidade sem rastreabilidade não é inovação; é risco operacional com aparência moderna.',
      },
    ],
  },
  {
    slug: 'resistencia-antimicrobiana-2025-consultorios-clinicas-odontologia',
    category: 'geral',
    title: 'Resistência antimicrobiana em 2025: o que muda na rotina de clínicas, consultórios e odontologia',
    description:
      'A resistência antimicrobiana exige prescrição mais criteriosa, comunicação clara com pacientes e integração entre medicina, odontologia e vigilância em saúde.',
    specialty: 'Segurança do paciente',
    audience: 'Médicos, dentistas e gestores assistenciais',
    updatedAt: '2026-05-25',
    readingMinutes: 7,
    keywords: ['resistência antimicrobiana', 'antibiotic stewardship', 'prescrição antibiótica', 'segurança do paciente'],
    sources: [
      {
        label: 'WHO - Global antibiotic resistance surveillance report 2025',
        url: 'https://www.who.int/publications/i/item/9789240116337',
      },
    ],
    sections: [
      {
        heading: 'Uma pauta global que chega ao atendimento diário',
        body:
          'A resistência antimicrobiana já afeta decisões em atenção primária, pronto atendimento, odontologia, cirurgia ambulatorial e internações. O desafio não é apenas microbiológico: envolve expectativa do paciente, pressão por “fazer algo”, falhas de seguimento e uso de antibióticos quando medidas locais, observação ou investigação seriam mais adequadas.',
      },
      {
        heading: 'O papel do consultório',
        body:
          'Mesmo fora do hospital, profissionais podem reduzir prescrição desnecessária, documentar indicação, dose e duração, orientar sinais de alarme e evitar antibióticos “preventivos” sem base. Em odontologia, dor, abscesso, drenagem, controle local e critérios sistêmicos precisam ser diferenciados para que o antibiótico não substitua tratamento definitivo.',
      },
      {
        heading: 'Comunicação é parte da intervenção',
        body:
          'Pacientes aceitam melhor não receber antibiótico quando entendem o motivo, o tempo esperado de evolução, o plano de retorno e os sinais que exigem reavaliação. Protocolos escritos, materiais educativos e mensagens padronizadas ajudam a equipe a sustentar condutas consistentes.',
      },
      {
        heading: 'Indicadores simples para começar',
        body:
          'Clínicas podem acompanhar taxa de prescrição por condição, duração média, reconsulta por piora, eventos adversos e adesão a protocolos. O objetivo não é reduzir antibiótico a qualquer custo, mas usar melhor quando há benefício real.',
      },
    ],
  },
  {
    slug: 'telemedicina-hibrida-2026-acesso-qualidade-seguimento',
    category: 'geral',
    title: 'Telemedicina híbrida: quando o digital melhora acesso sem empobrecer o cuidado',
    description:
      'A maturidade da telemedicina está em desenhar jornadas híbridas, com critérios claros para atendimento remoto, presencial e seguimento longitudinal.',
    specialty: 'Saúde digital',
    audience: 'Clínicas, médicos, dentistas e equipes de cuidado',
    updatedAt: '2026-05-25',
    readingMinutes: 7,
    keywords: ['telemedicina', 'saúde digital', 'jornada híbrida', 'acesso à saúde'],
    sources: [
      {
        label: 'PLOS Digital Health - Telemedicine in adult intensive care: systematic review',
        url: 'https://journals.plos.org/digitalhealth/article?id=10.1371%2Fjournal.pdig.0001126',
      },
      {
        label: 'Digital Health Transformation Through Telemedicine 2020-2025',
        url: 'https://www.mdpi.com/2673-8392/5/4/206',
      },
    ],
    sections: [
      {
        heading: 'A pergunta certa não é remoto versus presencial',
        body:
          'A telemedicina amadureceu quando deixou de ser “substituição da consulta” e passou a ser componente da jornada. Algumas situações ganham eficiência com atendimento remoto; outras exigem exame físico, procedimento, imagem, coleta ou avaliação de risco presencial. O valor está em saber classificar corretamente.',
      },
      {
        heading: 'Onde o modelo híbrido costuma funcionar melhor',
        body:
          'Seguimento de condições crônicas estáveis, revisão de exames, educação em saúde, segunda opinião documental, orientação pós-procedimento e triagem administrativa são usos naturais. Já dor aguda intensa, sinais neurológicos, dispneia, sangramento importante, suspeita de infecção grave e muitos quadros odontológicos exigem avaliação presencial rápida.',
      },
      {
        heading: 'Qualidade depende de processo',
        body:
          'Bons programas definem elegibilidade, consentimento, identidade do paciente, registro em prontuário, plano de contingência, encaminhamento presencial e métricas de desfecho. Sem isso, a telemedicina vira apenas uma videochamada; com processo, vira coordenação de cuidado.',
      },
      {
        heading: 'Oportunidade para clínicas',
        body:
          'A agenda híbrida permite reduzir faltas, melhorar seguimento, antecipar dúvidas e aumentar vínculo. Para isso, o digital precisa estar integrado ao prontuário, à agenda, à comunicação e às regras clínicas da equipe.',
      },
    ],
  },
  {
    slug: 'saude-oral-integrada-medicina-oportunidade-clinicas',
    category: 'geral',
    title: 'Saúde oral integrada à medicina: uma oportunidade clínica que ainda é subutilizada',
    description:
      'A integração entre odontologia e medicina ganha força em estratégias globais de saúde oral e abre espaço para cuidado mais preventivo e coordenado.',
    specialty: 'Medicina e odontologia integradas',
    audience: 'Médicos, dentistas, clínicas multidisciplinares e gestores',
    updatedAt: '2026-05-25',
    readingMinutes: 6,
    keywords: ['saúde oral', 'odontologia integrada', 'prevenção', 'cuidado multidisciplinar'],
    sources: [
      {
        label: 'WHO - Global strategy and action plan on oral health 2023-2030',
        url: 'https://iris.who.int/handle/10665/376623',
      },
      {
        label: 'WHO - Global oral health status report',
        url: 'https://www.who.int/publications/i/item/9789240061484',
      },
    ],
    sections: [
      {
        heading: 'Por que a boca voltou ao centro da discussão',
        body:
          'Doenças bucais estão entre as condições crônicas mais prevalentes do mundo e se relacionam com dor, nutrição, autoestima, absenteísmo e qualidade de vida. A agenda internacional tem defendido que saúde oral seja incorporada a políticas de cobertura universal, prevenção e atenção primária.',
      },
      {
        heading: 'Integração não é apenas encaminhar',
        body:
          'A integração real acontece quando médicos perguntam sobre saúde oral em grupos de risco, dentistas observam sinais sistêmicos relevantes, equipes compartilham alertas e pacientes recebem orientação coerente. Diabetes, gestação, oncologia, cardiologia, geriatria e pediatria são áreas com forte potencial de coordenação.',
      },
      {
        heading: 'Como começar na prática',
        body:
          'Clínicas podem criar checklists simples de risco oral, rotas de encaminhamento, campanhas preventivas, protocolos para pacientes imunossuprimidos e comunicação compartilhada. O ganho vem de reduzir cuidado fragmentado e detectar problemas antes que se tornem urgências.',
      },
      {
        heading: 'Mensagem para gestores',
        body:
          'A saúde oral integrada pode diferenciar serviços, melhorar prevenção e gerar novos fluxos assistenciais. O desafio é transformar a intenção multidisciplinar em processo mensurável.',
      },
    ],
  },
  {
    slug: 'burnout-prontuario-eletronico-redesenho-rotina-clinica',
    category: 'geral',
    title: 'Burnout, prontuário eletrônico e carga digital: como redesenhar a rotina clínica',
    description:
      'A discussão sobre burnout profissional passa por agenda, prontuário, mensagens, tarefas invisíveis e uso cuidadoso de automação.',
    specialty: 'Gestão e experiência profissional',
    audience: 'Profissionais de saúde, clínicas e gestores',
    updatedAt: '2026-05-25',
    readingMinutes: 7,
    keywords: ['burnout médico', 'prontuário eletrônico', 'carga administrativa', 'gestão clínica'],
    sources: [
      {
        label: 'JAMA Network Open - EHR usability, satisfaction and burnout',
        url: 'https://jamanetwork.com/journals/jamanetworkopen/article-abstract/2822959',
      },
      {
        label: 'JAMA - AI-drafted responses to patients and clinician burnout',
        url: 'https://jamanetwork.com/journals/jama/fullarticle/2817557',
      },
    ],
    sections: [
      {
        heading: 'A carga invisível também adoece',
        body:
          'Parte importante do desgaste profissional vem de tarefas que não aparecem na consulta: mensagens, formulários, documentação extensa, cliques repetitivos, retrabalho e interrupções. Melhorar burnout exige olhar para o desenho do trabalho, não apenas para resiliência individual.',
      },
      {
        heading: 'Prontuário bom é ferramenta clínica, não obstáculo',
        body:
          'Usabilidade ruim aumenta fricção, reduz satisfação e pode piorar a percepção de exaustão. Templates, frases inteligentes, campos realmente úteis e divisão de tarefas com a equipe ajudam, desde que não sacrifiquem qualidade do registro.',
      },
      {
        heading: 'Automação com supervisão',
        body:
          'Rascunhos de resposta, sumarização e organização de pendências podem reduzir carga administrativa, mas exigem revisão profissional e linguagem responsável. A automação deve diminuir ruído e risco, não acelerar respostas imprecisas.',
      },
      {
        heading: 'O indicador que importa',
        body:
          'Além de produtividade, acompanhe tempo fora do expediente, mensagens por profissional, atraso de registros, retrabalho, satisfação da equipe e incidentes. A rotina clínica saudável precisa ser medida como qualquer outro desfecho operacional.',
      },
    ],
  },
  {
    slug: 'ginecologia-menopausa-contracepcao-2026-decisao-compartilhada',
    category: 'especialidades',
    title: 'Ginecologia em 2026: menopausa, contracepção e decisão compartilhada no centro do cuidado',
    description:
      'Novas discussões internacionais reforçam cuidado individualizado, redução de medicalização excessiva e atualização de critérios de elegibilidade contraceptiva.',
    specialty: 'Ginecologista',
    audience: 'Ginecologistas, obstetras e clínicas de saúde da mulher',
    updatedAt: '2026-05-25',
    readingMinutes: 8,
    keywords: ['ginecologia', 'menopausa', 'contracepção', 'saúde da mulher'],
    sources: [
      {
        label: 'The Lancet - An empowerment model for managing menopause',
        url: 'https://www.sciencedirect.com/science/article/pii/S014067362302799X',
      },
      {
        label: 'CDC - U.S. Medical Eligibility Criteria for Contraceptive Use, 2024',
        url: 'https://www.cdc.gov/contraception/hcp/usmec/',
      },
      {
        label: 'ACOG - Menopause topic resources',
        url: 'https://www.acog.org/topics/menopause',
      },
    ],
    sections: [
      {
        heading: 'Menopausa além da prescrição',
        body:
          'A discussão internacional recente sobre menopausa propõe sair de uma visão puramente medicalizante e adotar modelo de empoderamento: sintomas importam, terapia hormonal pode ser indicada em perfis selecionados, mas contexto, preferências, risco individual e educação da paciente são decisivos.',
      },
      {
        heading: 'Contracepção cada vez mais personalizada',
        body:
          'Os critérios de elegibilidade contraceptiva atualizados reforçam avaliação de comorbidades, puerpério, trombose, obesidade, doença renal, lúpus, cardiopatias, interações medicamentosas e novos métodos. Para a prática, isso exige anamnese mais estruturada e documentação clara do raciocínio.',
      },
      {
        heading: 'Oportunidade de conteúdo e vínculo',
        body:
          'Pacientes buscam respostas sobre sangramento irregular, fogachos, libido, sono, contracepção após os 40 anos e riscos da terapia hormonal. Ginecologistas que produzem conteúdo técnico, equilibrado e sem alarmismo conseguem educar melhor e qualificar a consulta.',
      },
      {
        heading: 'Pergunta para a agenda profissional',
        body:
          'Sua clínica já tem protocolos escritos para perimenopausa, contracepção em comorbidades e acompanhamento de terapia hormonal? O diferencial pode estar menos na novidade terapêutica e mais na consistência da decisão compartilhada.',
      },
    ],
  },
  {
    slug: 'odontologia-2026-caries-periodontite-peri-implantite-prevencao',
    category: 'especialidades',
    title: 'Odontologia baseada em prevenção: cárie, periodontite e peri-implantite na agenda atual',
    description:
      'A odontologia moderna combina prevenção, manejo de biofilme, estratificação de risco e acompanhamento de implantes com protocolos consistentes.',
    specialty: 'Dentista',
    audience: 'Dentistas, clínicas odontológicas e equipes multiprofissionais',
    updatedAt: '2026-05-25',
    readingMinutes: 8,
    keywords: ['odontologia', 'cárie', 'periodontite', 'peri-implantite', 'prevenção oral'],
    sources: [
      {
        label: 'Clinical Oral Investigations - Periodontitis and dental caries systematic review',
        url: 'https://pubmed.ncbi.nlm.nih.gov/38727727/',
      },
      {
        label: 'Journal of Dentistry - EFP S3 guideline for peri-implant diseases',
        url: 'https://www.sciencedirect.com/science/article/pii/S0300571224001507',
      },
      {
        label: 'WHO - Global strategy and action plan on oral health 2023-2030',
        url: 'https://iris.who.int/handle/10665/376623',
      },
    ],
    sections: [
      {
        heading: 'A prevenção voltou a ser altamente estratégica',
        body:
          'Com o envelhecimento populacional, maior uso de implantes e alta carga global de doenças bucais, a odontologia precisa demonstrar valor para além do procedimento. Risco de cárie, saúde periodontal, manutenção de implantes e hábitos do paciente devem orientar frequência e plano de cuidado.',
      },
      {
        heading: 'Cárie e periodontite não são problemas isolados',
        body:
          'Revisões recentes reforçam que cárie e periodontite compartilham determinantes comportamentais, microbiológicos e sociais, embora tenham mecanismos distintos. O consultório precisa enxergar biofilme, dieta, higiene, tabagismo, diabetes, xerostomia e adesão como parte do mesmo ecossistema preventivo.',
      },
      {
        heading: 'Peri-implantite exige acompanhamento ativo',
        body:
          'Implante não encerra o tratamento; inaugura uma fase de manutenção. Protocolos de prevenção e tratamento de doenças peri-implantares reforçam controle de placa, monitoramento de tecidos, orientação do paciente e intervenção precoce diante de inflamação.',
      },
      {
        heading: 'Conteúdo que atrai pacientes certos',
        body:
          'Dentistas podem educar sobre sangramento gengival, manutenção de implantes, prevenção em pacientes diabéticos, halitose e risco de perda dentária. Conteúdo técnico bem explicado aumenta confiança e reduz procura tardia apenas em situação de dor.',
      },
    ],
  },
  {
    slug: 'tea-aba-2026-intervencoes-naturalisticas-medidas-desfecho',
    category: 'especialidades',
    title: 'TEA e ABA: o que profissionais devem acompanhar em intervenções, desfechos e participação familiar',
    description:
      'A literatura recente destaca intervenções individualizadas, participação familiar, medidas de desfecho funcionais e cuidado ético centrado na pessoa autista.',
    specialty: 'TEA ABA',
    audience: 'Analistas do comportamento, terapeutas, médicos e equipes multiprofissionais',
    updatedAt: '2026-05-25',
    readingMinutes: 8,
    keywords: ['TEA', 'ABA', 'autismo', 'intervenção comportamental', 'NDBI'],
    sources: [
      {
        label: 'Scientific Reports - Social training in ASD systematic review',
        url: 'https://www.nature.com/articles/s41598-024-83953-9',
      },
      {
        label: 'Springer - Parent-mediated NDBI systematic literature review',
        url: 'https://link.springer.com/article/10.1007/s40489-024-00439-0',
      },
      {
        label: 'PubMed - Community partnership in autism intervention research',
        url: 'https://pubmed.ncbi.nlm.nih.gov/38356206/',
      },
    ],
    sections: [
      {
        heading: 'A pergunta mudou: funciona para quem, em qual contexto?',
        body:
          'A discussão atual sobre intervenções no TEA não se resume a escolher uma abordagem. Profissionais precisam considerar idade, perfil de comunicação, objetivos funcionais, intensidade, ambiente, participação familiar, preferência da pessoa autista e generalização para a vida real.',
      },
      {
        heading: 'Desfechos devem ser funcionais',
        body:
          'Medir apenas horas de terapia ou redução de comportamentos é insuficiente. Bons programas acompanham comunicação, autonomia, participação social, qualidade de vida, adaptação familiar, habilidades de brincadeira, aprendizagem e bem-estar. O alvo deve ser ganho funcional e respeitoso, não normalização superficial.',
      },
      {
        heading: 'Família e comunidade são parte do tratamento',
        body:
          'Intervenções mediadas por pais e modelos naturalísticos ganham relevância porque favorecem prática em contextos cotidianos. Isso exige treinamento claro, metas realistas, supervisão e cuidado para não transferir carga excessiva à família.',
      },
      {
        heading: 'Ética como diferencial técnico',
        body:
          'Equipes de ABA e TEA precisam comunicar limites da evidência, evitar promessas de cura, registrar objetivos compartilhados e escutar a pessoa autista sempre que possível. A qualidade técnica hoje passa também por transparência e respeito à neurodiversidade.',
      },
    ],
  },
  {
    slug: 'cardiologia-hipertensao-2025-risco-cardiometabolico-prevent',
    category: 'especialidades',
    title: 'Cardiologia: hipertensão, risco cardiometabólico e prevenção personalizada após as diretrizes de 2025',
    description:
      'As diretrizes AHA/ACC 2025 reforçam prevenção, tratamento precoce, mensuração correta da pressão e uso de risco cardiovascular para personalizar condutas.',
    specialty: 'Cardiologista',
    audience: 'Cardiologistas, clínicos e equipes de prevenção cardiovascular',
    updatedAt: '2026-05-25',
    readingMinutes: 8,
    keywords: ['cardiologia', 'hipertensão', 'risco cardiovascular', 'PREVENT', 'AHA ACC 2025'],
    sources: [
      {
        label: 'AHA Professional Heart Daily - 2025 High Blood Pressure Guideline',
        url: 'https://professional.heart.org/en/guidelines-statements/2025-ahaaccaanpaapaabcaccpacpmagsamaaspcnmapcnasgim-guideline-for-thehyp0000000000000249',
      },
      {
        label: 'AHA Newsroom - New high blood pressure guideline',
        url: 'https://newsroom.heart.org/news/new-high-blood-pressure-guideline-emphasizes-prevention-early-treatment-to-reduce-cvd-risk',
      },
      {
        label: 'AHA - PREVENT equations and high blood pressure',
        url: 'https://newsroom.heart.org/news/the-prevent-equations-can-improve-personalize-care-for-adults-with-high-bp',
      },
    ],
    sections: [
      {
        heading: 'Hipertensão como porta de entrada para prevenção ampla',
        body:
          'As diretrizes recentes reforçam que hipertensão deve ser tratada no contexto de risco cardiovascular, renal e metabólico. Isso muda a conversa: não é apenas baixar números, mas reduzir eventos, proteger rim, cérebro e coração ao longo do tempo.',
      },
      {
        heading: 'Mensuração correta continua sendo tecnologia essencial',
        body:
          'Antes de intensificar tratamento, é preciso medir bem. Técnica inadequada, manguito incorreto, pressa e ausência de confirmação fora do consultório podem gerar decisões ruins. Protocolos de aferição e automedida validada seguem centrais para qualidade.',
      },
      {
        heading: 'Risco personalizado ganha força',
        body:
          'Ferramentas de estimativa de risco, como as equações PREVENT nos Estados Unidos, procuram integrar dimensões cardiovasculares, renais e metabólicas. Para o cardiologista, isso reforça abordagem individualizada e comunicação mais clara sobre benefício absoluto de intervenções.',
      },
      {
        heading: 'Conteúdo que engaja profissionais',
        body:
          'Temas como hipertensão em adultos jovens, adesão, automedida, risco residual, obesidade, doença renal e prevenção de demência vascular tendem a gerar leitura qualificada. A cardiologia preventiva está cada vez mais longitudinal e baseada em dados.',
      },
    ],
  },
  {
    slug: 'dermatologia-dermatite-atopica-terapias-sistemicas-barreira-cutanea',
    category: 'especialidades',
    title: 'Dermatologia: dermatite atópica, barreira cutânea e terapias modernas com decisão individualizada',
    description:
      'Guidelines recentes da AAD reforçam diagnóstico clínico, restauração da barreira cutânea e seleção criteriosa de terapias tópicas, sistêmicas e biológicas.',
    specialty: 'Dermatologista',
    audience: 'Dermatologistas, pediatras e clínicas de pele',
    updatedAt: '2026-05-25',
    readingMinutes: 7,
    keywords: ['dermatologia', 'dermatite atópica', 'barreira cutânea', 'AAD guidelines'],
    sources: [
      {
        label: 'American Academy of Dermatology - Atopic dermatitis clinical guideline',
        url: 'https://www.aad.org/practicecenter/quality/clinical-guidelines/atopic-dermatitis/diagnosis-and-assessment',
      },
      {
        label: 'PubMed - AAD guidelines for managing atopic dermatitis',
        url: 'https://pubmed.ncbi.nlm.nih.gov/38724796/',
      },
    ],
    sections: [
      {
        heading: 'Dermatite atópica como doença sistêmica e de barreira',
        body:
          'A dermatite atópica exige olhar além da lesão visível. Prurido, sono, saúde mental, infecções, aderência ao tratamento e impacto familiar devem entrar na avaliação. A restauração da barreira cutânea continua sendo base, mesmo quando terapias avançadas são consideradas.',
      },
      {
        heading: 'Terapias modernas aumentam a responsabilidade de seleção',
        body:
          'Imunobiológicos e inibidores de vias inflamatórias ampliaram opções para casos moderados a graves, mas exigem critérios claros de gravidade, falha terapêutica, contraindicações, preferência do paciente e monitoramento. A novidade terapêutica não substitui diagnóstico cuidadoso.',
      },
      {
        heading: 'Educação reduz recaídas',
        body:
          'Pacientes frequentemente subutilizam emolientes, temem corticoides tópicos ou interrompem tratamento ao melhorar. Conteúdo educativo sobre banho, hidratação, gatilhos, técnica de aplicação e sinais de infecção pode melhorar adesão e diminuir consultas por exacerbação.',
      },
      {
        heading: 'Tema fértil para SEO médico',
        body:
          'Dermatologistas podem produzir materiais sobre prurido crônico, dermatite em crianças, diferença entre alergia e dermatite, quando investigar infecção e como organizar tratamento de manutenção. A demanda por informação confiável é alta.',
      },
    ],
  },
  {
    slug: 'ortopedia-osteoartrite-quadril-dor-mobilidade-decisao-compartilhada',
    category: 'especialidades',
    title: 'Ortopedia: osteoartrite do quadril, dor e mobilidade com base em diretrizes atualizadas',
    description:
      'A atualização da AAOS para osteoartrite do quadril reforça cuidado baseado em evidências, função, qualidade de vida e decisão compartilhada.',
    specialty: 'Ortopedista',
    audience: 'Ortopedistas, fisiatras, fisioterapeutas e clínicas de dor',
    updatedAt: '2026-05-25',
    readingMinutes: 7,
    keywords: ['ortopedia', 'osteoartrite do quadril', 'dor no quadril', 'mobilidade', 'AAOS'],
    sources: [
      {
        label: 'AAOS - Updated guideline for management of osteoarthritis of the hip',
        url: 'https://www.aaos.org/aaos-home/newsroom/press-releases/aaos-updates-clinical-practice-guideline-for-the-management-of-osteoarthritis-of-the-hip/',
      },
    ],
    sections: [
      {
        heading: 'O foco é função, não apenas imagem',
        body:
          'A osteoartrite do quadril ilustra um desafio comum na ortopedia: alinhar achados de imagem, dor, mobilidade, expectativa do paciente e impacto funcional. A decisão clínica melhora quando a conversa sai do “grau de desgaste” e entra em metas de atividade, sono, trabalho e autonomia.',
      },
      {
        heading: 'Conservador e cirúrgico não são caminhos concorrentes',
        body:
          'Tratamento conservador, reabilitação, controle de peso, analgesia adequada e educação podem ser relevantes em diferentes fases. Quando a cirurgia entra em pauta, preparo pré-operatório, expectativa realista e seleção do paciente influenciam desfechos.',
      },
      {
        heading: 'Comunicação reduz frustração',
        body:
          'Pacientes querem saber quando a dor é compatível com artrose, quais atividades são seguras, quando infiltrações fazem sentido, quando considerar prótese e como evitar perda de mobilidade. Conteúdo claro ajuda a qualificar a consulta e reduzir medo de movimento.',
      },
      {
        heading: 'Agenda profissional',
        body:
          'Ortopedistas podem usar diretrizes como base para padronizar avaliação de dor, função, exames, indicação terapêutica e seguimento. A prática baseada em evidência precisa aparecer também na forma como a clínica educa e acompanha seus pacientes.',
      },
    ],
  },
];

export const getBlogArticleBySlug = (slug) => blogArticles.find((article) => article.slug === slug);

export const getRelatedBlogArticles = (article, limit = 3) =>
  blogArticles
    .filter((item) => item.slug !== article.slug && item.category === article.category)
    .slice(0, limit);
